import { render, staticRenderFns } from "./AirportHandlerPopup.vue?vue&type=template&id=32705d9a&"
import script from "./AirportHandlerPopup.vue?vue&type=script&lang=js&"
export * from "./AirportHandlerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports